export default "__VITE_ASSET__CyWt4RPn__"